import { useEffect, useRef, useState } from "react";

export default function useLayoutPreferences({ greaterThenSm, defaultMenu, userId, defaultTheme, themeMode, toggleColorMode }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const appliedTheme = useRef(null);

  useEffect(() => {
    setDrawerOpen(greaterThenSm && defaultMenu !== "closed");
  }, [greaterThenSm, defaultMenu]);

  useEffect(() => {
    if (!userId || !["dark", "light"].includes(defaultTheme)) return;
    const preference = `${userId}:${defaultTheme}`;
    if (appliedTheme.current === preference) return;
    // Apply the saved preference once; a manual theme switch survives resizing.
    appliedTheme.current = preference;
    if (themeMode !== defaultTheme) toggleColorMode();
  }, [userId, defaultTheme, themeMode, toggleColorMode]);

  return { drawerOpen, setDrawerOpen, drawerVariant: greaterThenSm ? "permanent" : "temporary" };
}
